import Dialog from "@stimulus-components/dialog"

export default class extends Dialog {
  static values = { autoOpen: Boolean }

  connect() {
    super.connect()

    if (this.autoOpenValue && this.hasDialogTarget && !this.dialogTarget.open) {
      this.dialogTarget.showModal()
    }
  }

  close() {
    // Émettre un événement personnalisé avant la fermeture
    const beforeCloseEvent = new CustomEvent('dialog:before-close', {
      bubbles: true,
      cancelable: true,
      detail: { dialog: this.dialogTarget }
    })
    
    this.element.dispatchEvent(beforeCloseEvent)
    
    // Si l'événement n'a pas été annulé, procéder à la fermeture
    if (!beforeCloseEvent.defaultPrevented) {
      super.close()
    }
  }
}